import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step } from '@/composables/tour/stepHelpers';

// The standalone Broadsheet Templates page was merged into the Results hub
// (Broadsheet tab), so its tour registration was removed — the admin-results
// tour covers the tab.

registerTourPage('admin-broadsheet-reports', {
  key: 'admin-broadsheet-reports',
  label: 'Broadsheet Reports',
  getSteps: () => [
    step({
      target: '#tour-broadsheet-report-filters',
      title: 'Generate a Report',
      content:
        'Pick the class (or programme + level for tertiary), the academic term, and a template — then click "Generate Report". Once it loads you can view it on screen, print it, or export to Excel.',
      placement: 'bottom',
    }),
  ],
});
